import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static targets = ['selectLanguages'];
  static values = { voteId: String };

  declare selectLanguagesTarget: HTMLSelectElement;
  declare voteIdValue: string;
  private previousUrl: string | null = null;

  initialize(): void {
    const selectLanguages = $(this.selectLanguagesTarget).select2({
      placeholder: 'Filter language',
      value: null
    })

    selectLanguages.on('change', (event) => this.filterLanguages(event));
  }

  private filterLanguages(event: Event): void {
    const selected = $(this.selectLanguagesTarget).val() as string[] || [];
    this.previousUrl = window.location.href

    const filterUrl = new URL(`/votes/translations/${this.voteIdValue}/filter`, window.location.origin);

    selected.forEach(lang => {
      filterUrl.searchParams.append('language_filters[]', lang);
    });

    Turbo.visit(filterUrl.toString(), {
      action: 'replace',
      frame: 'translations-form-container'
    });

    window.history.pushState({}, '', this.previousUrl)
  }
}
